export function getStatusText(status, pageTranslations) {
    switch (status) {
        case 'finished': return pageTranslations.statusFinished;
        case 'rejected': return pageTranslations.statusRejected;
        case 'failed': return pageTranslations.statusFailed;
        case 'running': return pageTranslations.statusRunning;
        default: return pageTranslations.statusNew;
    }
}

export function getStatusClass(status) {
    switch (status) {
        case 'finished': return 'text-[#0e8e6a] font-extrabold';
        case 'rejected':
        case 'failed': return 'text-[#dc3939] font-extrabold';
        case 'running': return 'text-[#f0ad4e] font-extrabold';
        default: return 'text-[#808080] font-extrabold';
    }
}
